// app/javascript/utils/i18n.js
export const t = (key, fallback) => {
  if (!window.I18n?.translations) return fallback !== undefined ? fallback : key;

  const keys = key.split('.');
  let value = window.I18n.translations;

  for (const k of keys) {
    value = value?.[k];
  }

  if (!value || value === key) {
    return fallback !== undefined ? fallback : key;
  }

  return value;
};

export const currentLocale = () => window.I18n?.locale || 'en';

